import { ContactService } from 'src/common/services/contact-enterprises/contact.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EnterprisesService } from 'src/common/services/form-enterprises/form.service';
import { Router } from '@angular/router';

@Component({
    selector: 'fe-app-form-enterprises',
    templateUrl: './form-enterprises.component.html',
    styleUrls: ['./form-enterprises.component.scss'],
})
export class FormEnterprisesComponent implements OnInit {
    form!: FormGroup;
    estados: string[] = [];
    municipios: string[] = [];
    loadingEstados = false;
    loadingMunicipios = false;

    // 🌍 Lista completa de países con su código y lada
    paises = [
        { nombre: 'Afganistán', codigo: 'AF', lada: '+93' },
        { nombre: 'Albania', codigo: 'AL', lada: '+355' },
        { nombre: 'Alemania', codigo: 'DE', lada: '+49' },
        { nombre: 'Andorra', codigo: 'AD', lada: '+376' },
        { nombre: 'Angola', codigo: 'AO', lada: '+244' },
        { nombre: 'Anguila', codigo: 'AI', lada: '+1-264' },
        { nombre: 'Antigua y Barbuda', codigo: 'AG', lada: '+1-268' },
        { nombre: 'Arabia Saudita', codigo: 'SA', lada: '+966' },
        { nombre: 'Argelia', codigo: 'DZ', lada: '+213' },
        { nombre: 'Argentina', codigo: 'AR', lada: '+54' },
        { nombre: 'Armenia', codigo: 'AM', lada: '+374' },
        { nombre: 'Aruba', codigo: 'AW', lada: '+297' },
        { nombre: 'Australia', codigo: 'AU', lada: '+61' },
        { nombre: 'Austria', codigo: 'AT', lada: '+43' },
        { nombre: 'Azerbaiyán', codigo: 'AZ', lada: '+994' },
        { nombre: 'Bahamas', codigo: 'BS', lada: '+1-242' },
        { nombre: 'Bangladés', codigo: 'BD', lada: '+880' },
        { nombre: 'Barbados', codigo: 'BB', lada: '+1-246' },
        { nombre: 'Baréin', codigo: 'BH', lada: '+973' },
        { nombre: 'Bélgica', codigo: 'BE', lada: '+32' },
        { nombre: 'Belice', codigo: 'BZ', lada: '+501' },
        { nombre: 'Benín', codigo: 'BJ', lada: '+229' },
        { nombre: 'Bermudas', codigo: 'BM', lada: '+1-441' },
        { nombre: 'Bielorrusia', codigo: 'BY', lada: '+375' },
        { nombre: 'Bolivia', codigo: 'BO', lada: '+591' },
        { nombre: 'Bosnia y Herzegovina', codigo: 'BA', lada: '+387' },
        { nombre: 'Botsuana', codigo: 'BW', lada: '+267' },
        { nombre: 'Brasil', codigo: 'BR', lada: '+55' },
        { nombre: 'Brunéi', codigo: 'BN', lada: '+673' },
        { nombre: 'Bulgaria', codigo: 'BG', lada: '+359' },
        { nombre: 'Burkina Faso', codigo: 'BF', lada: '+226' },
        { nombre: 'Burundi', codigo: 'BI', lada: '+257' },
        { nombre: 'Cabo Verde', codigo: 'CV', lada: '+238' },
        { nombre: 'Camboya', codigo: 'KH', lada: '+855' },
        { nombre: 'Camerún', codigo: 'CM', lada: '+237' },
        { nombre: 'Canadá', codigo: 'CA', lada: '+1' },
        { nombre: 'Chile', codigo: 'CL', lada: '+56' },
        { nombre: 'China', codigo: 'CN', lada: '+86' },
        { nombre: 'Chipre', codigo: 'CY', lada: '+357' },
        { nombre: 'Colombia', codigo: 'CO', lada: '+57' },
        { nombre: 'Corea del Sur', codigo: 'KR', lada: '+82' },
        { nombre: 'Costa Rica', codigo: 'CR', lada: '+506' },
        { nombre: 'Croacia', codigo: 'HR', lada: '+385' },
        { nombre: 'Cuba', codigo: 'CU', lada: '+53' },
        { nombre: 'Dinamarca', codigo: 'DK', lada: '+45' },
        { nombre: 'Dominica', codigo: 'DM', lada: '+1-767' },
        { nombre: 'Ecuador', codigo: 'EC', lada: '+593' },
        { nombre: 'Egipto', codigo: 'EG', lada: '+20' },
        { nombre: 'El Salvador', codigo: 'SV', lada: '+503' },
        { nombre: 'Emiratos Árabes Unidos', codigo: 'AE', lada: '+971' },
        { nombre: 'Eslovaquia', codigo: 'SK', lada: '+421' },
        { nombre: 'Eslovenia', codigo: 'SI', lada: '+386' },
        { nombre: 'España', codigo: 'ES', lada: '+34' },
        { nombre: 'Estados Unidos', codigo: 'US', lada: '+1' },
        { nombre: 'Estonia', codigo: 'EE', lada: '+372' },
        { nombre: 'Etiopía', codigo: 'ET', lada: '+251' },
        { nombre: 'Filipinas', codigo: 'PH', lada: '+63' },
        { nombre: 'Finlandia', codigo: 'FI', lada: '+358' },
        { nombre: 'Francia', codigo: 'FR', lada: '+33' },
        { nombre: 'Gabón', codigo: 'GA', lada: '+241' },
        { nombre: 'Gambia', codigo: 'GM', lada: '+220' },
        { nombre: 'Georgia', codigo: 'GE', lada: '+995' },
        { nombre: 'Ghana', codigo: 'GH', lada: '+233' },
        { nombre: 'Grecia', codigo: 'GR', lada: '+30' },
        { nombre: 'Guatemala', codigo: 'GT', lada: '+502' },
        { nombre: 'Guinea', codigo: 'GN', lada: '+224' },
        { nombre: 'Guyana', codigo: 'GY', lada: '+592' },
        { nombre: 'Haití', codigo: 'HT', lada: '+509' },
        { nombre: 'Honduras', codigo: 'HN', lada: '+504' },
        { nombre: 'Hungría', codigo: 'HU', lada: '+36' },
        { nombre: 'India', codigo: 'IN', lada: '+91' },
        { nombre: 'Indonesia', codigo: 'ID', lada: '+62' },
        { nombre: 'Irlanda', codigo: 'IE', lada: '+353' },
        { nombre: 'Islandia', codigo: 'IS', lada: '+354' },
        { nombre: 'Israel', codigo: 'IL', lada: '+972' },
        { nombre: 'Italia', codigo: 'IT', lada: '+39' },
        { nombre: 'Jamaica', codigo: 'JM', lada: '+1-876' },
        { nombre: 'Japón', codigo: 'JP', lada: '+81' },
        { nombre: 'Jordania', codigo: 'JO', lada: '+962' },
        { nombre: 'Kenia', codigo: 'KE', lada: '+254' },
        { nombre: 'Kuwait', codigo: 'KW', lada: '+965' },
        { nombre: 'Letonia', codigo: 'LV', lada: '+371' },
        { nombre: 'Líbano', codigo: 'LB', lada: '+961' },
        { nombre: 'Lituania', codigo: 'LT', lada: '+370' },
        { nombre: 'Luxemburgo', codigo: 'LU', lada: '+352' },
        { nombre: 'Madagascar', codigo: 'MG', lada: '+261' },
        { nombre: 'Malasia', codigo: 'MY', lada: '+60' },
        { nombre: 'Maldivas', codigo: 'MV', lada: '+960' },
        { nombre: 'Malta', codigo: 'MT', lada: '+356' },
        { nombre: 'Marruecos', codigo: 'MA', lada: '+212' },
        { nombre: 'México', codigo: 'MX', lada: '+52' },
        { nombre: 'Mónaco', codigo: 'MC', lada: '+377' },
        { nombre: 'Namibia', codigo: 'NA', lada: '+264' },
        { nombre: 'Nepal', codigo: 'NP', lada: '+977' },
        { nombre: 'Nicaragua', codigo: 'NI', lada: '+505' },
        { nombre: 'Nigeria', codigo: 'NG', lada: '+234' },
        { nombre: 'Noruega', codigo: 'NO', lada: '+47' },
        { nombre: 'Nueva Zelanda', codigo: 'NZ', lada: '+64' },
        { nombre: 'Países Bajos', codigo: 'NL', lada: '+31' },
        { nombre: 'Pakistán', codigo: 'PK', lada: '+92' },
        { nombre: 'Panamá', codigo: 'PA', lada: '+507' },
        { nombre: 'Paraguay', codigo: 'PY', lada: '+595' },
        { nombre: 'Perú', codigo: 'PE', lada: '+51' },
        { nombre: 'Polonia', codigo: 'PL', lada: '+48' },
        { nombre: 'Portugal', codigo: 'PT', lada: '+351' },
        { nombre: 'Puerto Rico', codigo: 'PR', lada: '+1-787' },
        { nombre: 'Reino Unido', codigo: 'GB', lada: '+44' },
        { nombre: 'República Checa', codigo: 'CZ', lada: '+420' },
        { nombre: 'República Dominicana', codigo: 'DO', lada: '+1-809' },
        { nombre: 'Rumania', codigo: 'RO', lada: '+40' },
        { nombre: 'Rusia', codigo: 'RU', lada: '+7' },
        { nombre: 'Serbia', codigo: 'RS', lada: '+381' },
        { nombre: 'Singapur', codigo: 'SG', lada: '+65' },
        { nombre: 'Sudáfrica', codigo: 'ZA', lada: '+27' },
        { nombre: 'Suecia', codigo: 'SE', lada: '+46' },
        { nombre: 'Suiza', codigo: 'CH', lada: '+41' },
        { nombre: 'Tailandia', codigo: 'TH', lada: '+66' },
        { nombre: 'Taiwán', codigo: 'TW', lada: '+886' },
        { nombre: 'Turquía', codigo: 'TR', lada: '+90' },
        { nombre: 'Ucrania', codigo: 'UA', lada: '+380' },
        { nombre: 'Uruguay', codigo: 'UY', lada: '+598' },
        { nombre: 'Venezuela', codigo: 'VE', lada: '+58' },
        { nombre: 'Vietnam', codigo: 'VN', lada: '+84' },
        { nombre: 'Zimbabue', codigo: 'ZW', lada: '+263' },
    ];

    selectedLada = '+52'; // por defecto México

    constructor(
        private fb: FormBuilder,
        private enterprisesService: EnterprisesService,
        private contactService: ContactService,
        private router: Router,
    ) {}

    ngOnInit(): void {
        this.form = this.fb.group({
            nombre: ['', Validators.required],
            pais: ['MX', Validators.required],
            telefono: ['', Validators.required],
            telefonoOficina: ['', Validators.required],
            correo: ['', [Validators.required, Validators.email]],
            estado: ['', Validators.required],
            municipio: ['', Validators.required],
            empresa: ['', Validators.required],
            giro: ['', Validators.required],
            puesto: ['', Validators.required],
            landing_page: [''],
        });
        let url = this.router.url;
        url = url.replace(/^\//, '');
        const landingPage = url.replace(/\//g, '_').replace(/-+/g, '_');
        this.form.patchValue({
            landing_page: landingPage,
        });

        this.form.get('pais')?.valueChanges.subscribe((codigoPais) => {
            const pais = this.paises.find((p) => p.codigo === codigoPais);
            this.selectedLada = pais ? pais.lada : '';
        });

        this.cargarEstados();

        this.form.get('estado')?.valueChanges.subscribe((estado) => {
            if (estado) this.cargarMunicipios(estado);
            else this.municipios = [];
        });
    }

    cargarEstados(): void {
        this.loadingEstados = true;
        this.enterprisesService.getEstados().subscribe({
            next: (res) => {
                this.estados = res.map((item: any) => item.nombre);
                this.loadingEstados = false;
            },
            error: (err) => {
                console.error('Error al cargar estados', err);
                this.loadingEstados = false;
            },
        });
    }

    cargarMunicipios(estado: string): void {
        this.loadingMunicipios = true;
        this.enterprisesService.getMunicipios(estado).subscribe({
            next: (res) => {
                this.municipios = res.map((item: any) => item.municipio);
                this.loadingMunicipios = false;
            },
            error: (err) => {
                console.error('Error al cargar municipios', err);
                this.loadingMunicipios = false;
            },
        });
    }

    onSubmit(): void {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            return;
        }

        const captcha = (window as any).grecaptcha.getResponse();
        if (!captcha) {
            alert('Por favor completa el CAPTCHA.');
            return;
        }

        const data = { ...this.form.value };
        const pais = this.paises.find((p) => p.codigo === data.pais);
        data.telefono = `${pais?.lada || ''}${data.telefono}`;

        this.contactService.sendContact(data, captcha).subscribe({
            next: () => {
                (window as any).grecaptcha.reset();
                this.form.reset();
                this.form.get('pais')?.setValue('MX');
                this.selectedLada = '+52';

                this.router.navigate(['/es/typ-empresas']);
            },
            error: (err) => {
                console.error('Error al enviar formulario', err);
                alert('Hubo un error al enviar el formulario.');
            },
        });
    }
}
